import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";

const weblinkUserKey: string = 'weblink-user';

@Injectable()
export class WeblinkUserService {

private subjectUserChanged = new Subject<string>();

  constructor() { }

  public getCurrentUser():string{
    let userItem = localStorage.getItem(weblinkUserKey);
    if (userItem) {
        return userItem;
    }
    return null;
  }

  public setCurrentUser(user:string){

    let userItem = localStorage.getItem(weblinkUserKey);
    if (userItem) {
        localStorage.removeItem(weblinkUserKey);
    }
    if (user)
        localStorage.setItem(weblinkUserKey, user);

    this.subjectUserChanged.next(user);
  }

  public get onUserChange():Observable<string>{
    return this.subjectUserChanged.asObservable();
    }

}
